import React from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { AdditionalDetails, ImageWrapper } from "./styles";
import { TICK_SCREEN_TEST_IDS } from "@swiggy-private/payment-test-ids";
import { ImageDimension } from "./constant";
import { isEmpty } from "@swiggy-private/js-utils";
import { TICK_STATES } from "../constants";

interface FooterProps {
    successFooterMessage?: { text: string; icon?: string };
    showContent: boolean;
    tickState: TICK_STATES;
}

const Footer: React.FC<FooterProps> = ({ successFooterMessage, showContent, tickState }) => {
    // Don't show savings text if savings is empty or tickState is not success
    if (isEmpty(successFooterMessage) || tickState !== TICK_STATES.SUCCESS) {
        return null;
    }

    return (
        <AdditionalDetails show={showContent}>
            <Text variant="V2.subheading1.neutral.medium" color="text_High_Emphasis" textAlign="center">
                {successFooterMessage.text}
            </Text>
            {!isEmpty(successFooterMessage.icon) && (
                <ImageWrapper data-testid={TICK_SCREEN_TEST_IDS.FOOTER_SUCCESS_ICON}>
                    <Image
                        cloudinaryId={successFooterMessage.icon}
                        width={`${ImageDimension.width}px`}
                        height={`${ImageDimension.height}px`}
                        alt="category icon"
                    />
                </ImageWrapper>
            )}
        </AdditionalDetails>
    );
};

export default Footer;
